module.exports = __webpack_public_path__ + "media/images/games/dota-2/background-9826746a8807bf0b233697150f59863b.jpg";